module.exports = __webpack_public_path__ + "checkbox-checked.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/checkbox-checked.svg?color1=%23FF4081&color2=
// module id = 2185
// module chunks = 67